module.exports = __webpack_public_path__ + "static/media/folder.07888da3.svg";